// src/components/common/CustomSelect.jsx

import React from "react";
import Select from "react-select";

const customStyles = {
    control: (base) => ({
        ...base,
        height: 55,
        minHeight: 55,
    }),
    valueContainer: (base) => ({
        ...base,
        height: 55,
        paddingTop: 0,
        paddingBottom: 0,
    }),
    input: (base) => ({
        ...base,
        margin: 0,
        padding: 0,
    }),
};

const CustomSelect = (props) => {
    return (
        <Select
            {...props}
            styles={{
                ...customStyles,
                ...props.styles, // امکان override کردن استایل‌ها در صورت نیاز
            }}
        />
    );
};

export default CustomSelect;
